import "./index.css";
// scroll bar
import "simplebar/src/simplebar.css";
// apex-chart
import "@/assets/third-party/apex-chart.css";

import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { captureBackendEnvFromUrl } from "@/utils/backend-env";
import { Environment, getEnvironment } from "@/utils/environments";

// project import
import App from "./App";
// import reportWebVitals from "reportWebVitals";

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

const environment = getEnvironment();
if (environment !== Environment.LOCAL) {
  Sentry.init({
    dsn: "https://b90c8fd41991302ecdebb12f50016050@o4507498102063104.ingest.us.sentry.io/4507498154164224",
    integrations: [],
    environment,
  });
}

// Stash `?dev1` / `?ppe` / etc. into sessionStorage before any router
// navigation can strip the query string. saveStructuredPolicy reads this on
// save and writes it as `_backendEnv` on the policy doc, which the trigger
// uses to route hydration to the matching aigent-service env.
captureBackendEnvFromUrl();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
